import { State } from 'interfaces/state'
import NetworthPage from 'components/features/pfm/NetworthPage/NetworthPage'
import { InternalPageProps } from 'interfaces/pages'
import { timeframeSelector } from 'selectors/globalSelectors'
import internal from 'components/utils/Internal'
import { Guards } from 'interfaces/guards'
import { linkedMixedAccountsGuard } from 'guards/linkageGuards'
import { connectShadedLoadable } from 'helpers/loadableHelpers'

const mapStateToProps = (state: State): InternalPageProps => ({
  timeframe: timeframeSelector(state, { type: 'networth' }),
})


const guards: Guards<{}> = [
  linkedMixedAccountsGuard,
]

const Connected = connectShadedLoadable<
  InternalPageProps
>(mapStateToProps, undefined, guards)(NetworthPage)

const ConnectedInternal = internal(Connected)
export default ConnectedInternal
